import React from 'react';
import { Shield, Ban, Zap, Search, Heart, MessageCircle, Send, Bookmark, MoreHorizontal, ThumbsUp, Share2, Home, Users, Bell, Menu, ChevronLeft, Square } from 'lucide-react';

const LOGO_URL = 'data:image/png;base64,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';

/* Realistic looking influencer-style stock photos (face will be blurred via overlay) */
const INFLUENCER_IMG_1 = null;
const INFLUENCER_IMG_2 = null;
const INFLUENCER_WOMAN = null;

/* ============== Anjora protect overlay ============== */
const AnjoraShield = ({ label = 'Acesso bloqueado pelo Anjora', sub = 'IA detectou conteúdo de aposta' }) => (
  <div className="absolute inset-0 flex flex-col items-center justify-center z-30 pointer-events-none px-4 overflow-hidden rounded-[inherit]">
    <div className="absolute w-44 h-44 rounded-full bg-cyan-500/30 blur-3xl animate-pulse-glow" />
    <div className="absolute w-28 h-28 rounded-full bg-blue-500/40 blur-2xl" />
    <img
      src={LOGO_URL}
      alt="Anjora"
      className="relative w-28 h-28 object-contain animate-float"
      style={{
        filter: 'drop-shadow(0 0 18px rgba(46,224,255,0.85)) drop-shadow(0 0 36px rgba(14,165,233,0.65))',
      }}
    />
    <div className="relative mt-2 w-full max-w-[200px]">
      <div className="rounded-xl px-3 py-2 backdrop-blur-md text-center"
        style={{
          background: 'rgba(8, 14, 28, 0.78)',
          border: '1px solid rgba(46, 224, 255, 0.45)',
          boxShadow: '0 0 24px rgba(14,165,233,0.35), inset 0 0 14px rgba(46,224,255,0.08)',
        }}
      >
        <p className="text-cyan-100 text-[10px] font-bold leading-tight">{label}</p>
        <p className="text-white/65 text-[8px] mt-0.5">{sub}</p>
      </div>
    </div>
  </div>
);

/* ============== Phone bottom nav (Android-like) ============== */
const PhoneNav = ({ light = false }) => (
  <div
    className={`absolute bottom-0 left-0 right-0 h-9 flex items-center justify-around z-20 ${
      light ? 'bg-white border-t border-black/5' : 'bg-black border-t border-white/10'
    }`}
  >
    <ChevronLeft className={`w-4 h-4 ${light ? 'text-black/70' : 'text-white/85'}`} />
    <div className={`w-3.5 h-3.5 rounded-full border-[1.5px] ${light ? 'border-black/70' : 'border-white/85'}`} />
    <Square className={`w-3.5 h-3.5 ${light ? 'text-black/70' : 'text-white/85'}`} />
  </div>
);

/* ============== Realistic bet ad with blurred face influencer ============== */
const BetAdImage = ({ img = null, brand = 'TIGRE DA SORTE', heightClass = 'h-44' }) => (
  <div className={`relative w-full ${heightClass} overflow-hidden bg-black`}>
    <div
      className="absolute inset-0"
      style={{
        background: 'radial-gradient(circle at 30% 50%, rgba(220,38,38,0.75) 0%, rgba(127,29,29,0.85) 45%, rgba(0,0,0,0.95) 100%)',
      }}
    />
    {/* Silhueta decorativa no lugar da foto */}
    <div className="absolute inset-0 flex items-center justify-center opacity-20">
      <div className="w-24 h-32 rounded-full bg-white/30" style={{borderRadius: '50% 50% 45% 45%'}} />
    </div>
    {/* Brand title (bet typography) */}
    <div className="absolute top-2 right-2 text-right z-[2]">
      <p
        className="text-yellow-300 text-[12px] font-black italic leading-none tracking-wide"
        style={{ textShadow: '1.5px 1.5px 0 #7f1d1d, 0 0 8px rgba(251,191,36,0.55)' }}
      >
        {brand.split(' ').slice(0, 1).join(' ')}
      </p>
      <p
        className="text-yellow-300 text-[12px] font-black italic leading-none tracking-wide"
        style={{ textShadow: '1.5px 1.5px 0 #7f1d1d, 0 0 8px rgba(251,191,36,0.55)' }}
      >
        {brand.split(' ').slice(1).join(' ')}
      </p>
      <p className="text-white/95 text-[7px] font-bold tracking-widest mt-0.5 bg-red-700/70 px-1 rounded">.bet</p>
    </div>
    {/* Bottom ribbon bonus + CTA */}
    <div className="absolute bottom-1.5 left-1.5 right-1.5 flex items-end justify-between z-[2]">
      <div
        className="px-2 py-1 rounded"
        style={{
          background: 'linear-gradient(135deg, #fbbf24, #f59e0b)',
          boxShadow: '0 0 10px rgba(251,191,36,0.45)',
        }}
      >
        <p className="text-red-900 text-[8px] font-black leading-none">BÔNUS R$ 500</p>
        <p className="text-red-900/80 text-[6.5px] font-bold leading-none mt-0.5">no 1º depósito</p>
      </div>
      <div
        className="px-2.5 py-1 rounded"
        style={{ background: 'linear-gradient(135deg, #16a34a, #15803d)' }}
      >
        <p className="text-white text-[8px] font-black tracking-wider leading-none">JOGUE AGORA</p>
      </div>
    </div>
  </div>
);

/* ============== INSTAGRAM ============== */
const InstagramScreen = () => (
  <div className="absolute inset-0 flex flex-col bg-black">
    <div className="flex justify-between items-center px-5 pt-9 pb-1 text-[10px] text-white">
      <span>14:08</span>
      <span>5G</span>
    </div>
    {/* Header */}
    <div className="flex items-center justify-between px-4 pt-2 pb-2 border-b border-white/10">
      <span className="text-white text-[15px]" style={{ fontFamily: 'cursive', fontWeight: 600 }}>
        Instagram
      </span>
      <div className="flex items-center gap-3">
        <Heart className="w-4 h-4 text-white" />
        <Send className="w-4 h-4 text-white" />
      </div>
    </div>
    {/* Sponsored post header */}
    <div className="px-3 pt-3 pb-2 flex items-center gap-2">
      <div className="w-7 h-7 rounded-full p-[1.5px]" style={{ background: 'linear-gradient(45deg, #f09433, #dc2743, #bc1888)' }}>
        <div
          className="w-full h-full rounded-full bg-gradient-to-br from-pink-400 to-purple-600"
        />
      </div>
      <div className="flex-1">
        <p className="text-white text-[10px] font-semibold leading-tight flex items-center gap-1">
          <span className="filter blur-[2px] select-none">●●●●●●_oficial</span>
          <span className="w-2.5 h-2.5 rounded-full bg-blue-500 inline-flex items-center justify-center">
            <span className="text-white text-[6px] font-black leading-none">✓</span>
          </span>
        </p>
        <p className="text-white/55 text-[8px]">Patrocinado</p>
      </div>
      <MoreHorizontal className="w-4 h-4 text-white" />
    </div>
    {/* Realistic ad image with blurred influencer (woman) */}
    <BetAdImage img={INFLUENCER_WOMAN} brand="REINA SLOTS" heightClass="h-44" />
    {/* Action bar */}
    <div className="flex items-center justify-between px-3 pt-2">
      <div className="flex gap-3">
        <Heart className="w-4 h-4 text-white" />
        <MessageCircle className="w-4 h-4 text-white" />
        <Send className="w-4 h-4 text-white" />
      </div>
      <Bookmark className="w-4 h-4 text-white" />
    </div>
    <div className="px-3 pt-1">
      <p className="text-white text-[9px]">
        <span className="font-semibold">Curtido por <span className="filter blur-[1.5px]">●●●●_</span> e mais 18,2K</span>
      </p>
      <p className="text-white text-[9px] mt-0.5">
        <span className="font-semibold filter blur-[1.5px]">●●●●●●●_oficial</span>{' '}
        <span className="text-white/85">Saquei R$ 12.450 ontem! 💰 Cadastre na bio</span>
      </p>
    </div>
    <AnjoraShield label="Anúncio bloqueado pelo Anjora" sub="Influenciador · Instagram" />
    <PhoneNav />
  </div>
);

/* ============== FACEBOOK ============== */
const FacebookScreen = () => (
  <div className="absolute inset-0 flex flex-col bg-[#18191A]">
    <div className="flex justify-between items-center px-5 pt-9 pb-1 text-[10px] text-white">
      <span>16:42</span>
      <span>5G</span>
    </div>
    {/* Header */}
    <div className="flex items-center justify-between px-3 pt-2 pb-2">
      <span className="text-[20px] font-black tracking-tight" style={{ color: '#1877F2' }}>facebook</span>
      <div className="flex items-center gap-2">
        <div className="w-6 h-6 rounded-full bg-[#3A3B3C] flex items-center justify-center">
          <Search className="w-3 h-3 text-white" />
        </div>
        <div className="w-6 h-6 rounded-full bg-[#3A3B3C] flex items-center justify-center">
          <MessageCircle className="w-3 h-3 text-white" />
        </div>
      </div>
    </div>
    <div className="flex justify-around py-1.5 border-b border-white/10">
      <Home className="w-4 h-4" style={{ color: '#1877F2' }} />
      <Users className="w-4 h-4 text-white/55" />
      <Bell className="w-4 h-4 text-white/55" />
      <Menu className="w-4 h-4 text-white/55" />
    </div>
    {/* Sponsored bet post header */}
    <div className="px-3 pt-2 pb-1.5 flex items-center gap-2">
      <div
        className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-400 to-blue-700"
      />
      <div className="flex-1">
        <p className="text-white text-[10px] font-semibold leading-tight flex items-center gap-1">
          <span className="filter blur-[2px] select-none">●●●●● ●●●●●●●</span>
          <span className="w-2.5 h-2.5 rounded-full bg-blue-500 inline-flex items-center justify-center">
            <span className="text-white text-[6px] font-black leading-none">✓</span>
          </span>
        </p>
        <p className="text-white/55 text-[8px]">Patrocinado · 2h</p>
      </div>
      <MoreHorizontal className="w-4 h-4 text-white/70" />
    </div>
    <div className="px-3 pb-1.5">
      <p className="text-white/90 text-[9px] leading-snug">
        Galera, paguei minhas contas com o app! Saque <span className="font-bold text-yellow-400">R$ 5.000</span> ontem 🔥
      </p>
    </div>
    {/* Realistic ad image */}
    <BetAdImage img={INFLUENCER_IMG_2} brand="TIGRE SORTE" heightClass="h-32" />
    {/* Reactions */}
    <div className="flex items-center justify-between px-3 py-1.5 border-b border-white/5">
      <div className="flex items-center gap-1">
        <div className="flex -space-x-1">
          <div className="w-3.5 h-3.5 rounded-full bg-blue-500 flex items-center justify-center"><ThumbsUp className="w-2 h-2 text-white" fill="currentColor" /></div>
          <div className="w-3.5 h-3.5 rounded-full bg-red-500" />
        </div>
        <span className="text-white/55 text-[8px]">8,4K</span>
      </div>
      <span className="text-white/55 text-[8px]">312 comentários</span>
    </div>
    {/* Action bar */}
    <div className="flex items-center justify-around px-2 py-1.5">
      <div className="flex items-center gap-1">
        <ThumbsUp className="w-3.5 h-3.5 text-white/70" />
        <span className="text-white/70 text-[9px]">Curtir</span>
      </div>
      <div className="flex items-center gap-1">
        <MessageCircle className="w-3.5 h-3.5 text-white/70" />
        <span className="text-white/70 text-[9px]">Comentar</span>
      </div>
      <div className="flex items-center gap-1">
        <Share2 className="w-3.5 h-3.5 text-white/70" />
        <span className="text-white/70 text-[9px]">Compart.</span>
      </div>
    </div>
    <AnjoraShield label="Cassino bloqueado pelo Anjora" sub="Influenciador · Facebook" />
    <PhoneNav />
  </div>
);

/* ============== GOOGLE (dark version) ============== */
const GoogleScreen = () => (
  <div className="absolute inset-0 flex flex-col bg-[#0a0a0a]">
    <div className="flex justify-between items-center px-5 pt-9 pb-1 text-[10px] text-white/80">
      <span className="font-medium">10:24</span>
      <span className="font-medium">5G</span>
    </div>
    {/* Search bar */}
    <div className="px-3 pt-3 pb-2">
      <div className="flex items-center gap-2 px-3 py-2 rounded-full border border-white/10 bg-[#1f1f1f]">
        <div className="flex items-center gap-0.5 text-[11px] font-bold">
          <span style={{ color: '#4285F4' }}>G</span>
          <span style={{ color: '#EA4335' }}>o</span>
          <span style={{ color: '#FBBC05' }}>o</span>
          <span style={{ color: '#4285F4' }}>g</span>
          <span style={{ color: '#34A853' }}>l</span>
          <span style={{ color: '#EA4335' }}>e</span>
        </div>
        <span className="text-white/85 text-[10px] truncate flex-1">bet entrar</span>
        <div className="w-3 h-3 rounded-full bg-gradient-to-br from-blue-500 to-yellow-400" />
      </div>
      <div className="flex gap-3 px-1 pt-3 pb-2 border-b border-white/10">
        <span className="text-[10px] text-blue-400 font-semibold border-b-2 border-blue-400 pb-1">Tudo</span>
        <span className="text-[10px] text-white/50">Imagens</span>
        <span className="text-[10px] text-white/50">Vídeos</span>
        <span className="text-[10px] text-white/50">Notícias</span>
      </div>
    </div>
    <div className="px-3 pt-3 space-y-3">
      <div>
        <div className="flex items-center gap-1 mb-1">
          <span className="text-[8px] font-bold text-white/85 px-1 border border-white/30 rounded">Patrocinado</span>
          <span className="text-[9px] text-white/55">tigredasorte.bet</span>
        </div>
        <p className="text-[12px] font-medium text-blue-300 leading-tight">Tigre da Sorte — Bônus de R$ 500</p>
        <p className="text-[9px] text-white/55 leading-snug mt-0.5">
          Aposte no cassino ao vivo, slots e jogos. Cadastre-se e ganhe seu bônus de boas-vindas...
        </p>
      </div>
      <div>
        <div className="flex items-center gap-1 mb-1">
          <span className="text-[8px] font-bold text-white/85 px-1 border border-white/30 rounded">Patrocinado</span>
          <span className="text-[9px] text-white/55">slotpremium.com.br</span>
        </div>
        <p className="text-[12px] font-medium text-blue-300 leading-tight">Slot Premium — Saque rápido no PIX</p>
        <p className="text-[9px] text-white/55 leading-snug mt-0.5">
          O melhor cassino online do Brasil. Mais de 1.000 jogos disponíveis 24h...
        </p>
      </div>
      <div>
        <p className="text-[12px] font-medium text-blue-300 leading-tight">Tigre da Sorte — Cadastro</p>
        <p className="text-[9px] text-emerald-400 leading-tight">tigredasorte.bet › cadastro</p>
        <p className="text-[9px] text-white/55 leading-snug mt-0.5">
          Crie sua conta em 30 segundos. Apostas esportivas e cassino...
        </p>
      </div>
    </div>
    <AnjoraShield label="Pesquisa bloqueada pelo Anjora" sub="bet · Google · IA detectou" />
    <PhoneNav />
  </div>
);

/* ============== ANJORA HOME ============== */
const HomeScreen = () => (
  <div className="absolute inset-0 flex flex-col bg-gradient-to-b from-[#0a1428] to-[#05070d]">
    <div className="flex justify-between items-center px-5 pt-9 pb-1 text-[10px] text-white/70">
      <span>09:41</span>
      <span>5G</span>
    </div>
    <div className="px-5 pt-3 pb-4">
      <p className="text-white/50 text-[10px]">Bom dia, Carlos</p>
      <h3 className="text-white text-lg font-bold">Você está protegido</h3>
    </div>
    <div className="px-5">
      <div className="rounded-2xl p-4 mb-3" style={{ background: 'linear-gradient(135deg, rgba(20,184,166,0.18), rgba(14,165,233,0.18))', border: '1px solid rgba(46,224,255,0.25)' }}>
        <div className="flex items-center gap-2 mb-2">
          <Shield className="w-4 h-4 text-cyan-300" />
          <span className="text-cyan-200 text-[11px] font-semibold">Proteção ativa</span>
        </div>
        <p className="text-white text-2xl font-bold">12 dias</p>
        <p className="text-white/60 text-[10px]">livre de apostas — continue assim!</p>
      </div>
      <div className="grid grid-cols-2 gap-2 mb-3">
        <div className="rounded-xl p-3 bg-white/[0.04] border border-white/5">
          <Ban className="w-4 h-4 text-teal-400 mb-2" />
          <p className="text-white text-base font-bold">142</p>
          <p className="text-white/50 text-[9px]">bloqueios hoje</p>
        </div>
        <div className="rounded-xl p-3 bg-white/[0.04] border border-white/5">
          <Zap className="w-4 h-4 text-cyan-400 mb-2" />
          <p className="text-white text-base font-bold">2.840</p>
          <p className="text-white/50 text-[9px]">no mês</p>
        </div>
      </div>
      <div className="rounded-xl p-3 bg-white/[0.04] border border-white/5">
        <div className="flex items-center justify-between mb-1.5">
          <span className="text-white text-[11px] font-semibold">IA monitorando 24h</span>
          <div className="w-8 h-4 rounded-full bg-cyan-500 flex items-center justify-end px-0.5">
            <div className="w-3 h-3 rounded-full bg-white" />
          </div>
        </div>
        <p className="text-white/50 text-[9px]">Google · redes sociais · sites</p>
      </div>
    </div>
    <PhoneNav />
  </div>
);

/* ============== COUNTS ============== */
const CountsScreen = () => {
  const sources = [
    { src: 'Google', count: 47, color: '#3b82f6' },
    { src: 'Instagram', count: 38, color: '#ec4899' },
    { src: 'Facebook', count: 26, color: '#1877F2' },
    { src: 'TikTok', count: 24, color: '#06b6d4' },
    { src: 'YouTube', count: 19, color: '#ef4444' },
  ];
  return (
    <div className="absolute inset-0 flex flex-col bg-gradient-to-b from-[#0a1428] to-[#05070d]">
      <div className="flex justify-between items-center px-5 pt-9 pb-1 text-[10px] text-white/70">
        <span>20:14</span>
        <span>5G</span>
      </div>
      <div className="px-5 pt-3 pb-3">
        <p className="text-white/50 text-[10px]">Hoje</p>
        <h3 className="text-white text-lg font-bold leading-tight">Bloqueios por origem</h3>
      </div>
      <div className="px-5 pb-3">
        <div className="rounded-2xl p-4" style={{ background: 'linear-gradient(135deg, rgba(20,184,166,0.18), rgba(14,165,233,0.18))', border: '1px solid rgba(46,224,255,0.25)' }}>
          <p className="text-cyan-200 text-[10px] font-semibold mb-1">Total do dia</p>
          <p className="text-white text-3xl font-extrabold">154</p>
          <p className="text-white/60 text-[9px]">tentativas bloqueadas pela IA</p>
        </div>
      </div>
      <div className="flex-1 px-4 pb-10 space-y-2">
        {sources.map((it, i) => (
          <div key={i} className="rounded-xl p-2.5 bg-white/[0.04] border border-white/5 flex items-center gap-3">
            <div
              className="w-7 h-7 rounded-lg flex items-center justify-center flex-shrink-0"
              style={{ background: `${it.color}22`, border: `1px solid ${it.color}55` }}
            >
              <Ban className="w-3.5 h-3.5" style={{ color: it.color }} />
            </div>
            <span className="text-white text-[10px] font-semibold flex-1">{it.src}</span>
            <span className="text-white/80 text-[11px] font-bold">{it.count}</span>
          </div>
        ))}
      </div>
      <PhoneNav />
    </div>
  );
};

const PhoneMockup = ({ variant = 'home', highlighted = false, scan = false }) => {
  const Screen =
    variant === 'google' ? GoogleScreen :
    variant === 'instagram' || variant === 'social' ? InstagramScreen :
    variant === 'facebook' ? FacebookScreen :
    variant === 'consciencia' || variant === 'counts' ? CountsScreen :
    HomeScreen;

  return (
    <div className={`phone-frame relative ${highlighted ? 'glow-blue' : 'glow-soft'}`}>
      <div className="phone-notch" />
      <Screen />
      {scan && (
        <>
          <div className="scan-overlay" />
          <div className="scan-corners absolute inset-0 pointer-events-none rounded-[34px]" />
          <div className="absolute top-3 left-1/2 -translate-x-1/2 z-40 px-2.5 py-1 rounded-full bg-black/80 border border-cyan-400/40 backdrop-blur-md flex items-center gap-1.5">
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />
            <span className="text-[8px] font-bold tracking-widest text-cyan-200">IA ANALISANDO</span>
          </div>
        </>
      )}
    </div>
  );
};

export default PhoneMockup;
